export default "__VITE_ASSET__91c46b1f__"